import { render, staticRenderFns } from "./RecommendedStudent.vue?vue&type=template&id=178999b1&scoped=true"
import script from "./RecommendedStudent.vue?vue&type=script&lang=js"
export * from "./RecommendedStudent.vue?vue&type=script&lang=js"
import style0 from "./RecommendedStudent.vue?vue&type=style&index=0&id=178999b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178999b1",
  null
  
)

export default component.exports